import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@mui/material';

type StepButtonsType = {
  lastStep?: boolean;
  firstStep?: boolean;
  onBack?: () => void;
  onNext?: () => void;
  onSubmit?: () => void;
}
const RegisterStepButtons: React.FC<StepButtonsType> = ({
  lastStep,
  firstStep,
  onBack,
  onNext,
  onSubmit,
}: StepButtonsType) => (
  <div>
    {!firstStep && (
      <Button
        onClick={onBack}
      >
        <FormattedMessage id="back" />
      </Button>
    )}
    {!lastStep
      ? (
        <Button
          sx={{ m: 1 }}
          variant="contained"
          id="RegistrationNext"
          disableTouchRipple
          disableFocusRipple
          color="primary"
          onClick={onNext}
          disabled={!onNext}
        >
          <FormattedMessage id="next" />
        </Button>
      )
      : (
        <Button
          sx={{ m: 1 }}
          variant="contained"
          id="RegistrationComplete"
          disableTouchRipple
          disableFocusRipple
          color="primary"
          onClick={onSubmit}
          disabled={!onSubmit}
        >
          <FormattedMessage id="registration.submit" />
        </Button>
      )}
  </div>
);

export default RegisterStepButtons;
